import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Button } from '../button/button'

export const SwiperContainer = styled.div`
  @media (min-width: 569px) and (max-width: 911px) {
    padding-inline: 24px;
    width: 100%;
  }

  @media (max-width: 568px) {
    display: none;
  }
`

export const CarouselContainer = styled.div`
  display: flex;
  gap: 16px;
  position: relative;
  width: 100%;

  @media (min-width: 569px) and (max-width: 911px) {
    padding-inline: 48px;
  }

  @media (min-width: 569px) {
    display: none;
  }

  @media (max-width: 568px) {
    & > .carousel {
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: 40px;
      position: relative;
      width: 100%;

      img {
        height: 100%;
        width: 100%;
      }

      &:has(.dots) {
        padding-bottom: 118px;
      }

      .dots {
        bottom: 0px;
      }
    }
  }
`
export const CarouselButton = styled(Button)`
  bottom: 48px;
  left: 0;
  margin: 0 auto;
  max-width: 312px;
  padding: 8px 24px;
  position: absolute;
  right: 0;
  width: 100%;

  @media (min-width: 569px) {
    display: none;
  }
`

export const TestimonialLink = styled(Link)`
  box-shadow: 0px 10px 20px -10px #E3DFD740;
  position: relative;

  & > img {
    border-radius: 16px;
    min-height: 192px;
    max-height: 192px;
    max-width: 312px;
    min-width: 312px;
  }

  @media (max-width: 568px) {
    & > img {
      max-height: 100%;
      min-height: 100%;
      max-width: 100%;
      min-width: 100%;
    }
  }
`
